import React, { useState } from 'react';
import axios from 'axios';

const domainesAvecSous = {
  informatique: ['développement', 'industrie', 'administration'],
  industrialisation: ['logistique', 'production'],
  'agri business': ['sur terrain', 'laboratoire', 'locale'],
};

const VisiteAffaire = () => {
  const [formData, setFormData] = useState({
    typeVisite: '',
    domaine: '',
    sousDomaine: ''
  });

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
      ...(name === 'domaine' ? { sousDomaine: '' } : {})
    }));
  };

const handleSubmit = async e => {
  e.preventDefault();
  try {
    await axios.post(`${process.env.REACT_APP_API_URL}/visite`, formData);
    setFormData({ typeVisite: '', domaine: '', sousDomaine: '' });
    setModalMessage("✅ Données envoyées ! Nous vous enverrons par email la suite de votre demande.");
    setShowModal(true);
  } catch (err) {
    setModalMessage("❌ Une erreur est survenue. Veuillez réessayer.");
    setShowModal(true);
  }
};


  const showDomaine = formData.typeVisite !== '';
  const showSousDomaine = formData.domaine && domainesAvecSous[formData.domaine];

  return (
    <>
      <div style={{ display: 'flex', padding: '2rem', maxWidth: '1000px', margin: 'auto', gap: '2rem' }}>
        {/* Description */}
        <div style={{
          flex: 1,
          background: '#f8f9fa',
          padding: '2rem',
          borderRadius: '10px',
          boxShadow: '0 0 10px rgba(0,0,0,0.1)'
        }}>
          <h2>Visite d'Affaire</h2>
          <p><strong>Exploration :</strong> Pour découvrir les métiers sur le terrain.</p>
          <p><strong>Immersion :</strong> Pour vivre une expérience concrète dans un domaine.</p>
          <p><strong>Les deux :</strong> Combinez découverte et expérience en entreprise.</p>
          <p>Choisissez une visite et indiquez vos préférences pour un accompagnement sur mesure.</p>
        </div>

        {/* Formulaire */}
        <div style={{
          flex: 1,
          background: '#fff',
          padding: '2rem',
          borderRadius: '10px',
          border: '1px solid #ddd',
          boxShadow: '0 0 8px rgba(0,0,0,0.05)',
          marginTop: '1.5rem'
        }}>
          <h3>Formulaire de demande</h3>
          <form onSubmit={handleSubmit}>
            <label style={{ display: 'block', marginBottom: '1rem' }}>
              Type de visite:
              <select
                name="typeVisite"
                value={formData.typeVisite}
                onChange={handleChange}
                required
                style={{ marginTop: '0.5rem', width: '100%', padding: '0.5rem' }}
              >
                <option value="">-- Sélectionnez --</option>
                <option value="exploration">Exploration</option>
                <option value="immersion">Immersion</option>
                <option value="les deux">Les deux</option>
              </select>
            </label>

            {showDomaine && (
              <label style={{ display: 'block', marginBottom: '1rem' }}>
                Domaine:
                <select
                  name="domaine"
                  value={formData.domaine}
                  onChange={handleChange}
                  required
                  style={{ marginTop: '0.5rem', width: '100%', padding: '0.5rem' }}
                >
                  <option value="">-- Sélectionnez --</option>
                  <option value="informatique">Informatique et développement</option>
                  <option value="industrialisation">Informatique et industrie</option>
                  <option value="agri business">Agri Business</option>
                  <option value="médical">Médical</option>
                  <option value="transport">Transport</option>
                </select>
              </label>
            )}

            {showSousDomaine && (
              <label style={{ display: 'block', marginBottom: '1rem' }}>
                Sous-domaine:
                <select
                  name="sousDomaine"
                  value={formData.sousDomaine}
                  onChange={handleChange}
                  required
                  style={{ marginTop: '0.5rem', width: '100%', padding: '0.5rem' }}
                >
                  <option value="">-- Sélectionnez --</option>
                  {domainesAvecSous[formData.domaine].map((sous, index) => (
                    <option key={index} value={sous}>{sous}</option>
                  ))}
                </select>
              </label>
            )}

            <button type="submit" style={{
              marginTop: '1rem',
              padding: '0.7rem 1.5rem',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}>
              Envoyer
            </button>
          </form>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            background: '#fff',
            padding: '2rem',
            borderRadius: '10px',
            width: '90%',
            maxWidth: '500px',
            boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
            textAlign: 'center'
          }}>
            <p style={{ marginBottom: '1rem' }}>{modalMessage}</p>
            <button onClick={() => setShowModal(false)} style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}>
              Fermer
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default VisiteAffaire;
